import React from "react";
import "./page404.css";

const Page404 = () => {
  return (
    <div className="page404">
      <span className="span404">404</span>
      <span className="message404">Pas trouvé</span>
    </div>
  );
};

export default Page404;
